<template>
  <div>
    <v-row>
      <!-- 契約情報 -->
      <v-col cols="6">
        <v-row>
          <v-col>
            <h3>契約情報</h3>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <app-label-group label="契約">
              <template #value>
                <div class="ml-3">
                  {{
                    $filter.enumTo(
                      cpaContractInfo.contractType,
                      "cpaContractType"
                    )
                  }}/
                </div>
                <div class="ml-3">
                  {{
                    $filter.enumTo(
                      cpaContractInfo.authenticationType,
                      "cpaAuthenticationType"
                    )
                  }}
                </div>
              </template>
            </app-label-group>
          </v-col>
        </v-row>
        <!-- 冗長 -->
        <v-row>
          <v-col>
            <app-label-group
              label="冗長"
              :value="
                $filter.enumTo(cpaContractInfo.redundancy, 'cpaRedundancy')
              "
            />
          </v-col>
        </v-row>
        <!-- アドレスアサイン方式 -->
        <v-row>
          <v-col>
            <app-label-group
              label="アドレスアサイン方式"
              :value="
                $filter.enumTo(
                  cpaContractInfo.addressAssignmentMethod,
                  'cpaAddressAssignMethod'
                )
              "
            />
          </v-col>
        </v-row>
        <!-- 品目 -->
        <v-row>
          <v-col>
            <app-label-group label="品目">
              <template #value>
                <div class="ml-3">
                  <span v-if="cpaContractInfo.bandwidthType === 'BEST_EFFORT'">
                    ベストエフォート:1Gbps
                  </span>
                  <span v-else-if="cpaContractInfo.wnumber">
                    {{ "帯域確保:" + cpaContractInfo.bandwidth!.value
                    }}{{
                      $filter.enumTo(
                        cpaContractInfo.bandwidth!.unit,
                        "bandwidth_unit"
                      )
                    }}
                  </span>
                  <span v-else>帯域確保</span>
                </div>
              </template>
            </app-label-group>
          </v-col>
        </v-row>
        <!-- ドメイン -->
        <v-row>
          <v-col>
            <app-label-group label="ドメイン" :value="cpaContractInfo.domain" />
          </v-col>
        </v-row>
        <!-- IPアドレス -->
        <v-row>
          <v-col>
            <app-label-group
              label="IPアドレス"
              :value="
                $filter.enumTo(
                  cpaContractInfo.ipAddressType,
                  'cpaIpAddressType'
                )
              "
            />
          </v-col>
        </v-row>
      </v-col>

      <!-- 基本情報 -->
      <v-col cols="6">
        <v-row>
          <v-col>
            <h3>基本情報</h3>
          </v-col>
        </v-row>
        <!-- VPN/VNコード -->
        <v-row>
          <v-col>
            <app-label-group
              label="VPN/VNコード"
              :value="
                cpaContractInfo.vpnVnCode.startsWith('B')
                  ? cpaContractInfo.vpnVnCode
                  : cpaContractInfo.vpnVnCode +
                    '(' +
                    cpaContractInfo.vnName +
                    ')'
              "
            />
          </v-col>
        </v-row>
        <!-- ACTサイト -->
        <v-row>
          <v-col>
            <app-label-group label="ACTサイト">
              <template #value>
                <div class="ml-3">
                  {{
                    cpaContractInfo.redundancy === "EAST_ACT_WEST_SBY"
                      ? "東日本"
                      : "西日本"
                  }}
                </div>
                <div class="ml-3">
                  {{
                    cpaContractInfo.wnumber
                      ? cpaContractInfo.wnumber.wnumberAct
                      : "-"
                  }}
                </div>
              </template>
            </app-label-group>
          </v-col>
        </v-row>
        <!-- SBYサイト -->
        <v-row>
          <v-col>
            <app-label-group label="SBYサイト">
              <template #value>
                <div class="ml-3">
                  {{
                    cpaContractInfo.redundancy === "EAST_ACT_WEST_SBY"
                      ? "西日本"
                      : "東日本"
                  }}
                </div>
                <div class="ml-3">
                  {{
                    cpaContractInfo.wnumber
                      ? cpaContractInfo.wnumber.wnumberSby
                      : "-"
                  }}
                </div>
              </template>
            </app-label-group>
          </v-col>
        </v-row>
        <!-- APN -->
        <v-row>
          <v-col>
            <app-label-group label="APN" :value="cpaContractInfo.apn" />
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row class="mt-3">
      <v-col>
        <!-- NW設定状況 -->
        <v-row>
          <v-col>
            <h3>NW設定状況</h3>
          </v-col>
        </v-row>
        <!-- ステータス -->
        <v-row>
          <v-col>
            <app-label-group
              label="ステータス"
              :value="
                $filter.enumTo(cpaContractInfo.status, 'cpaContractStatus')
              "
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { CpaContract } from "@/apis/Cpa5gSaApi";

export default defineComponent({
  name: "SaNwContractInfo",
  props: {
    /** CPA契約情報 */
    cpaContractInfo: {
      type: Object as PropType<CpaContract>,
      required: true,
    },
  },
});
</script>
